import { render, staticRenderFns } from "./LawyerPartyStep.vue?vue&type=template&id=19780aa9"
import script from "./LawyerPartyStep.vue?vue&type=script&lang=ts"
export * from "./LawyerPartyStep.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports